import { GET_GOLF_COURSE, GET_GOLF_COURSE_SUCCESS, GET_GOLF_COURSE_ERROR, GET_GOLF_COURSE_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetGolfCourses = (state = initialState, action) => {
  switch (action.type) {
    case GET_GOLF_COURSE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_GOLF_COURSE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_GOLF_COURSE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_GOLF_COURSE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetGolfCourses;
